import Web3 from "web3";
import MainContractAbi from "../abi/mainContractAbi.json";
import UsdtContractAbi from "../abi/usdtAbi.json";
import { mainContract, usdtContracts } from "../../constants/constant";
import { useDistributeRewardApiCallMutation } from "../../services/api/users/users.api";

interface MultisendValues {
  recipients: string[];
  amount: number;
}

interface BlockchainFunctionReturn {
  multisendUsdt: (web3: any, userAddress: any, values: any,campaginId:any) => Promise<boolean>;
}

const BlockchainFunction = (): BlockchainFunctionReturn => {

    const [distributeReward] = useDistributeRewardApiCallMutation();

  const multisendUsdt = async (
    web3: Web3,
    userAddress: string,
    values: MultisendValues,
    campaginId:any
  ): Promise<boolean> => {
    try {
      console.log("Multisending USDT...", values, userAddress, web3);
      const { recipients, amount } = values;

      if (!recipients.length) {
        console.log("Recipients array cannot be empty.");
        return false;
      }

      if (!amount || amount <= 0) {
        console.log("Amount must be positive.");
        return false;
      }

      const usdtContract = new web3.eth.Contract(UsdtContractAbi as any, usdtContracts);
      const mainContractInstance = new web3.eth.Contract(MainContractAbi as any, mainContract);

      // Convert amount to USDT smallest unit (6 decimals)
      const amountInWei = BigInt(web3.utils.toWei(amount.toString(), "mwei"));
      const amountsArray = recipients.map(() => amountInWei.toString());
      const totalAmount = amountsArray.reduce((acc, val) => acc + BigInt(val), BigInt(0));

      // Check balance
      const balance = BigInt(await usdtContract.methods.balanceOf(userAddress).call());
      if (balance < totalAmount) {
        console.log("Insufficient USDT balance.");
        return false;
      }

      // Check allowance
      const allowance = BigInt(await usdtContract.methods.allowance(userAddress, mainContract).call());
      if (allowance < totalAmount) {
        console.log("Requesting USDT approval...");

        await usdtContract.methods.approve(mainContract, totalAmount.toString())
          .send({ from: userAddress })
          .on("transactionHash", (hash: string) => console.log("Approve Tx Hash:", hash));

        console.log("✅ USDT approval successful.");
      }

      // Call multisend
      console.log("Sending multisend transaction...");

      const txReceipt = await mainContractInstance.methods
        .multiSendUsdt(recipients, amountsArray)
        .send({ from: userAddress })
        .once("transactionHash", (hash) => console.log("Tx Hash:", hash));
      console.log("txReceipt", txReceipt);
        if (txReceipt.status) {
        console.log("✅ USDT multisend confirmed!");

        // Call the distributeReward API
        try {
          await distributeReward({
            _ids: recipients,
            amount,
            hash: txReceipt.transactionHash,
            campaignId:campaginId,
          }).unwrap();
          console.log("✅ Reward distribution recorded successfully!");
          return true;
        } catch (apiError: any) {
          console.log("Failed to record reward distribution:", apiError.message || apiError);
          return false; // Consider whether to return false here or true since blockchain tx succeeded
        }
      } else {
        console.log("❌ Transaction failed on-chain.");
        return false;
      }

    } catch (error: any) {
      console.log("Transaction failed:", error.message || error);
      return false;
    }
  };

  return { multisendUsdt };
};

export default BlockchainFunction;
